import React from "react";

const Toast = ({ message, onToastHide, id }) => {
  return (
    <div
      className="toast fade show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="toast-header">
        <strong className="mr-auto">
          <i className="fa-solid fa-bell"></i> &nbsp; Notification
        </strong>
        <small className="text-muted"></small>
        <button
          onClick={() => onToastHide(id)}
          type="button"
          className="ml-2 mb-1 close"
          data-dismiss="toast"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="toast-body">{message}</div>
    </div>
  );
};

export default Toast;
